import {
  useGetAdditionalEmailFromMyExamCard,
  useGetExamResultByCardIdQuery,
} from '@exam-room/graphql';
import { useNavigate, useParams } from 'react-router-dom';

import { LoadingSpinner } from '../../../../components';
import { useGetExamEventSettings } from '../../../../hooks';
import { useAuth } from '../../../../providers';
import { PATHS } from '../../../constants';
import LogoutButtonWithCountdown from '../../containers/logout-button-with-countdown';
import { ExamResultCard } from '../components';
import ExamineeCertificateInfoCard from '../components/examinee-certificate-info-card';

function ExamResult() {
  // TODO: get examCardId from provider
  const { examCardId } = useParams();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const { isLoading: isGetResultSettingsLoading, settings } = useGetExamEventSettings({
    cardId: examCardId as string,
  });

  const { loading: isGetExamResultLoading, data: examResultData } = useGetExamResultByCardIdQuery({
    fetchPolicy: 'cache-first',
    variables: {
      examCardId: examCardId as string,
    },
  });

  const {
    loading: isGetAdditionalEmailFromMyExamCardLoading,
    data: getAdditionalEmailFromMyExamCardData,
  } = useGetAdditionalEmailFromMyExamCard();

  const examResultSettings = settings.result;
  const delayedDays = examResultSettings.delayedDays;

  const examResult = examResultData?.erGetExamResultByCardId?.isPassed;

  const email = user?.email;
  const additionalEmail = getAdditionalEmailFromMyExamCardData?.erGetMyExamCard.additionalEmail;

  const shouldDisplayCertificateInfo = examResultSettings.hasCertificate;

  const handleLogout = async () => {
    await logout();
    navigate(PATHS.Home);
  };

  if (examResult === undefined) return null;

  const isLoading =
    isGetResultSettingsLoading ||
    isGetExamResultLoading ||
    isGetAdditionalEmailFromMyExamCardLoading;

  if (isLoading)
    return (
      <div className='grid h-dvh w-screen place-items-center'>
        <LoadingSpinner />
      </div>
    );

  const examResultVariant = examResult ? 'passed' : 'failed';

  return (
    <ExamResultCard variant={examResultVariant} delayedDays={delayedDays}>
      {shouldDisplayCertificateInfo ? (
        <ExamineeCertificateInfoCard email={email} additionalEmail={additionalEmail} />
      ) : null}
      <LogoutButtonWithCountdown className='w-full' onLogout={handleLogout} countdownTime={120} />
    </ExamResultCard>
  );
}

export default ExamResult;
